<template>
    <div class="pantalla-menu">
        <div class="container-mob w-100 pb-0">

            <buscador-component></buscador-component>

            <div class="text-end mt-4">
                <a href="javascript: window.history.back()" class="color-red pe-3">
                    <i class="fas fa-chevron-left"></i>
                </a>
            </div>

            <div class="producto">
                <h3 class="mb-2">Resultados de la búsqueda:</h3>
            </div>
            <div class="row" v-if="this.products.length > 0">
                <div class="col-6" v-for="(producto, key) in products">
                    <div class="series text-center position-relative py-2">
                        <router-link :to="{ name: 'producto', params: { slug: producto.slug } }">
                            <img :src="'/storage/'+producto.imagenes[0]" class="imagen-producto">
                            <p class="color-red mt-3 mb-0">{{ producto.nombre }}</p>
                        </router-link>
                    </div>
                </div>
            </div>

            <div v-else>
                <p>0 productos encontrados.</p>
            </div>

        </div>
        <menu-component></menu-component>
    </div>
</template>

<script>

export default {
    data() {
        return {
            products: [],
            errors: null
        };
    },
    methods: {
    },
    mounted: function () {
        this.$store
        .dispatch("getBusqueda", {
            query: this.$route.query.q
        })
        .then(response => {
            this.products = response.data;
        })
        .catch(error => {
            this.errors = error.response.data;
        });
    }
};
</script>
